module.exports = {
      id: "ic-area-grayscale-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-area-grayscale-usage",
      toString: function () {
        return this.url;
      }
    }